import React from 'react'
import PropTypes from 'prop-types'
import { getButton } from 'Shared/GTM/getButton'

const NavTabHeader = ({ isBusinessActive, focusOutOnClick }) => {
  return (
    <nav aria-label='Segmento' className='menu menu-segmentation'>
      <div className='container'>
        <div
          className='flexible-items-container'
          role='menubar'
          aria-label='selecionar o seguimento'
        >
          <a
            id='para-voce'
            href='/'
            aria-label={`Para você ${!isBusinessActive ? 'página atual' : ''}`}
            className={`flex-item mn-item mn-personal ${
              !isBusinessActive ? 'active' : ''
            }`}
            role='menuitem'
            onClick={() => {
              focusOutOnClick()
              getButton(false, 'home', 'clique:botao', 'para-voce')
            }}
          >
            Para você
          </a>
          <a
            id='meu-negocio'
            href='/meu-negocio'
            aria-label={`Para seu negócio ${isBusinessActive ? 'página atual' : ''}`}
            className={`flex-item mn-item mn-business ${
              isBusinessActive ? 'active' : ''
            }`}
            role='menuitem'
            onClick={() => {
              focusOutOnClick()
              getButton(false, 'home', 'clique:botao', 'para-seu-negocio')
            }}
          >
            Para o seu negócio
          </a>
        </div>
      </div>
    </nav>
  )
}

NavTabHeader.propTypes = {
  isBusinessActive: PropTypes.bool,
  focusOutOnClick: PropTypes.func
}
export default NavTabHeader



// WEBPACK FOOTER //
// ./src/App/Header/NavTabHeader.js